var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockerUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 14.4H2.75054C2.18543 14.4 1.76812 13.8424 1.98127 13.3296C2.97021 10.9584 5.29354 9.59998 7.99988 9.59998C10.707 9.59998 13.0304 10.9584 14.0193 13.3296C14.2325 13.8424 13.8152 14.4 13.25 14.4ZM4.73333 4.79998C4.73333 3.03518 6.1992 1.59998 7.99988 1.59998C9.80138 1.59998 11.2664 3.03518 11.2664 4.79998C11.2664 6.56478 9.80138 7.99998 7.99988 7.99998C6.1992 7.99998 4.73333 6.56478 4.73333 4.79998ZM15.9645 14.1088C15.3708 11.4216 13.5138 9.43838 11.0696 8.53838C12.3648 7.51678 13.1202 5.86478 12.8425 4.05598C12.5208 1.95758 10.7389 0.278382 8.58786 0.0335815C5.61857 -0.304818 3.10006 1.95918 3.10006 4.79998C3.10006 6.31198 3.81543 7.65918 4.93096 8.53838C2.48595 9.43838 0.629731 11.4216 0.0352192 14.1088C-0.180373 15.0856 0.623197 16 1.64318 16H14.3566C15.3774 16 16.1809 15.0856 15.9645 14.1088Z",
    fill: "#3B414D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerUser);
export default __webpack_public_path__ + "static/media/locker-user.b901348dc6d81125d75b06a3453ba047.svg";
export { ForwardRef as ReactComponent };